

/**
 * Это очень важный файл, здесь мы тоже работаем, например модифицируем enum'ы и тд.
 *
 * Здесь происходит вторая регистрация проектов и контекстов.
 *
 * Никакого хардкода!!
 */

import { isServer } from 'shared/constants/isServer';
import { bString } from './core';
import { ApplicationShared } from './core';
import { DEZIIIGN_CONTEXTS } from 'shared/constants/enginePaths';

export enum AppName {
  deziiign = 'deziiign',
  geograffee = 'geograffee',
  designlab = 'labolatory',
  gallllery = 'gallllery',
  mediiia = 'mediiia',
  competition = 'competition',
  hsedesign = 'hsedesign',
  dafesNetKZ = 'kz',
  fr = 'fr',
  uz = 'uz',
  ftbl = 'ftbl',
}

export enum AppContext {
  education = 'education',
  main = 'main',
  design = 'design',
  art = 'art',
  fashion = 'fashion',
  events = 'events',
  space = 'space',
  urban = 'urban',
  places = 'places',
}

export enum AppMode {
  production = 'production',
  develop = 'develop',
  staging = 'staging',
}

const AppContextTitleMap: Record<string, string> = {
  education: 'education',
  main: 'deziiign',
  design: 'design',
  art: 'art',
  fashion: 'fashion',
  events: 'events',
  space: 'space',
  media: 'creative',
  places: 'places',
  creative: 'creative',
};

/**
 * Конфигурация стартера
 */
export const StarterSettings = {
  // Стартовый файл
  appStarterFile: 'app.tsx',

  // Стартовый заголовок
  appDefaultTitle: 'Burgundy Engine',
};

/**
 * Получение контекста из названия мини-приложения
 * @param appName
 */
export const getContextFromAppName = (appName: string): string => {
  const parts = appName.split('/');

  const contextName = parts.length === 1 || !parts[1] || bString.isEmpty(parts[1]) ? 'main' : parts[1];

  if (contextName === 'hsealumni') {
    return 'education'
  }

  return contextName;
};

export const getAppNameFromAppString = (appName: string): string => appName.split('/')[0];

export const getCurrentContextName = (): string => getContextFromAppName(ApplicationShared.application);

export const getCurrentContextTitle = (): string => AppContextTitleMap[getCurrentContextName()] || '';

/**
 * Возвращает название  мини-приложения ЗАПУЩЕННОГО В ТЕКУЩИЙ МОМЕНТ
 */
export const getCurrentAppName = (): string => getAppNameFromAppString(ApplicationShared.application);

// const safeWindow = isServer ? {
//     location: {
//         pathname: '/',
//     }
// } : window;

export const buildAppTester = (getApplication: () => string) => {
  const getContextName = () => getContextFromAppName(getApplication());
  const getAppName = () => getAppNameFromAppString(getApplication());
  const isContext = (c?: string): boolean => getContextName() === c;
  const isApp = (a?: string): boolean => getAppName() === a;

  return {
    isContext,
    isApp,
    getContextName,
    getAppName,
    // Тестирование приложений
    isDeziiign: (): boolean => isApp('deziiign') || isApp('fr') || isApp('uz'),
    isGallllery: (): boolean => isApp('gallllery'),
    isMediiiaMain: (): boolean => isApp('deziiign') && isContext('mediiia'),
    isMediiiaStories: (): boolean => isApp('deziiign') && isContext('storiesmediiia'),
    isMediiiaNature: (): boolean => isApp('deziiign') && isContext('naturemediiia'),
    isMediiiaSport: (): boolean => isApp('deziiign') && isContext('sportmediiia'),
    isMediiiaProf: (): boolean => isApp('deziiign') && isContext('profmediiia'),
    isMediiiaCine: (): boolean => isApp('deziiign') && isContext('cinemediiia'),
    isMediiiaAi: (): boolean => isApp('deziiign') && isContext('aimediiia'),
    isMediiiaArt: (): boolean => isApp('deziiign') && isContext('artmediiia'),
    isMediiiaFair: (): boolean => isApp('deziiign') && isContext('fairmediiia'),
    isMediiiaAd: (): boolean => isApp('deziiign') && isContext('admediiia'),
    isKiiidsMediiia: (): boolean => isApp('deziiign') && isContext('kiiidsmediiia'),
    isMediiiaKiiids: (): boolean => isApp('deziiign') && isContext('kiiidsmediiia'),
    isMediiiaUrban: (): boolean => isApp('deziiign') && isContext('urbanmediiia'),
    isMediiiaFood: (): boolean => isApp('deziiign') && isContext('foodmediiia'),
    isMediiiaAuto: (): boolean => isApp('deziiign') && isContext('automediiia'),
    isMediiiaConcept: (): boolean => isApp('deziiign') && isContext('conceptmediiia'),  
    isDesignMediiia: (): boolean => isApp('deziiign') && isContext('designmediiia'),
    isHistoryMediiia: (): boolean => isApp('deziiign') && isContext('historymediiia'),
    isMusicMediiia: (): boolean => isApp('deziiign') && isContext('musicmediiia'),
    isMediiia365: (): boolean => isApp('deziiign') && isContext('365'),
    isEventMediiia: (): boolean => isApp('deziiign') && isContext('eventmediiia'),
    isArtMediiia: (): boolean => isApp('deziiign') && isContext('artmediiia'),
    isAstroMediiia: (): boolean => isApp('deziiign') && isContext('astromediiia'),
    isMyMediiia: (): boolean => isApp('deziiign') && isContext('mymediiia'),
    isGeograffee: (): boolean => isApp('geograffee'),
    isAgeytomesh: (): boolean => isContext('ageytomesh'),
    isCompetition: (): boolean => isApp('competition'),
    isFairArtz: (): boolean => isApp('deziiign') && isContext('fairartz'),
    isPortfolioArtz: (): boolean => isApp('deziiign') && isContext('portfolioartz'),
    isArtzWork: (): boolean => isApp('deziiign') && isContext('fairartz') || isContext('portfolioartz'),
    isJhonataNet: (): boolean => isApp('deziiign') && isContext('jhonatanet'),
    // Контексты
    isMainContext: (): boolean => isContext('main'),
    isLabDeziiign: (): boolean => isApp('deziiign') && isContext('lab'),
    isHSEBiotech: (): boolean => isApp('deziiign') && isContext('s-biology'),
    isHSESpaceSegmants: (): boolean => isContext('s-architect')
      || isContext('s-biology')
    || isContext('s-hseissek')
      || isContext('s-oriental')
      || isContext('s-geography')
      || isContext('s-hseincomm')
      || isContext('s-digital')
      || isContext('s-history')
      || isContext('s-arthistory')
      || isContext('s-cinema')
      || isContext('s-cognitive')
      || isContext('s-culturology')
      || isContext('s-mathematics')
      || isContext('s-media')
      || isContext('s-fashion')
      || isContext('s-music')
      || isContext('s-production')
      || isContext('s-pro')
      || isContext('s-hsetto')
      || isContext('s-psychology')
      || isContext('s-public-administration')
      || isContext('s-physics')
      || isContext('s-chemistry')
      || isContext('s-economy')
      || isContext('s-extra')
      || isContext('hsespacecreative')
      || isContext('hsespacefilm')
      || isContext('s-urban-development')
      || isContext('s-computer-science-and-engineering')
      || isContext('s-international-relations')
      || isContext('s-management')
      || isContext('s-political-science')
      || isContext('s-advertising-and-pr')
      || isContext('s-software-engineering')
      || isContext('s-sociology')
      || isContext('s-philology')
      || isContext('s-philosophy')
      || isContext('s-jurisprudence')
      || isContext('s-mediadepartment')
      || isContext('hsecreativehub')
      || isContext('s-virtualspace')
      || isContext('s-biology'),
    // Контексты Deziiign
    isDeziiignMain: (): boolean => isApp('deziiign') && isContext('main'),
    isDeziiignContext: (): boolean => DEZIIIGN_CONTEXTS.includes(getApplication()),
    isDeziiignEssential: (): boolean => isApp('deziiign') && !(
      (isApp('deziiign') && (isContext('hsedesign')
        || isContext('prohse')
        || isContext('lmshse')
        || isContext('hsehh')
        || isContext('hsecolors')
        || isContext('hsecreative')
        || isContext('damuseum')
        || isContext('hsestart')
        || isContext('exams')
        || isContext('hsespace')
        || (isContext('s-architect')
          || isContext('s-biology')
          || isContext('s-hseissek')
          || isContext('s-oriental')
          || isContext('s-geography')
          || isContext('s-hseincomm')
          || isContext('s-digital')
          || isContext('s-history')
          || isContext('s-arthistory')
          || isContext('s-cinema')
          || isContext('s-cognitive')
          || isContext('s-culturology')
          || isContext('s-mathematics')
          || isContext('s-media')
          || isContext('s-fashion')
          || isContext('s-music')
          || isContext('s-production')
          || isContext('s-pro')
          || isContext('s-hsetto')
          || isContext('s-psychology')
          || isContext('s-public-administration')
          || isContext('s-physics')
          || isContext('s-chemistry')
          || isContext('s-economy')
          || isContext('s-extra')
          || isContext('hsespacecreative')
          || isContext('hsespacefilm')
          || isContext('s-urban-development')
          || isContext('s-computer-science-and-engineering')
          || isContext('s-international-relations')
          || isContext('s-management')
          || isContext('s-political-science')
          || isContext('s-advertising-and-pr')
          || isContext('s-mediadepartment')
          || isContext('s-software-engineering')
          || isContext('s-sociology')
          || isContext('s-philology')
          || isContext('s-philosophy')
          || isContext('s-jurisprudence')
          || isContext('hsecreativehub')
        )
      )) || (isApp('deziiign') && isContext('onlines')) || (isApp('deziiign') && isContext('school'))
    ),
    isHSEDesign: (): boolean => isApp('deziiign') && (isContext('hsedesign')
      || isContext('prohse')
      || isContext('lmshse')
      || isContext('hsehh')
      || isContext('hsecolors')
      || isContext('hsecreative')
      || isContext('damuseum')
      || isContext('hsestart')
      || isContext('exams')
      || isContext('hsespace')
      || (
        isContext('s-architect')
        || isContext('s-biology')
        || isContext('s-hseissek')
        || isContext('s-oriental')
        || isContext('s-geography')
        || isContext('s-hseincomm')
        || isContext('s-digital')
        || isContext('s-history')
        || isContext('s-arthistory')
        || isContext('s-cinema')
        || isContext('s-cognitive')
        || isContext('s-culturology')
        || isContext('s-mathematics')
        || isContext('s-media')
        || isContext('s-fashion')
        || isContext('s-music')
        || isContext('s-production')
        || isContext('s-pro')
        || isContext('s-hsetto')
        || isContext('s-psychology')
        || isContext('s-public-administration')
        || isContext('s-physics')
        || isContext('s-chemistry')
        || isContext('s-economy')
        || isContext('s-extra')
        || isContext('hsespacecreative')
        || isContext('hsespacefilm')
        || isContext('s-urban-development')
        || isContext('s-computer-science-and-engineering')
        || isContext('s-international-relations')
        || isContext('s-management')
        || isContext('s-political-science')
        || isContext('s-advertising-and-pr')
        || isContext('s-software-engineering')
        || isContext('s-sociology')
        || isContext('s-philology')
        || isContext('s-philosophy')
        || isContext('s-jurisprudence')
        || isContext('s-mediadepartment')
        || isContext('hsecreativehub')
      )
    ),
    isOnlineHSEDesign: (): boolean => isApp('deziiign') && isContext('online'),
    isOnlines: (): boolean => isApp('deziiign') && isContext('onlines'),
    isOnlinesDesign: (): boolean => isApp('deziiign') && isContext('onlinesdesign'),
    isMediiia: (): boolean => isApp('deziiign') && (isContext('mediiia')
      || isContext('lmsmediiia')
      || isContext('namesmediiia')
      || isContext('sciencemediiia')
      || isContext('iqmedia')
      || isContext('historymediiia')
      || isContext('transfermediiia')
      || isContext('creativemediiia')
      || isContext('sportmediiia')
      || isContext('profmediiia')
      || isContext('cinemediiia')
      || isContext('aimediiia')
      || isContext('historymediiia')
      || isContext('sportmediiia')
      || isContext('eventmediiia')
      || isContext('musicmediiia')
      || isContext('storiesmediiia')
      || isContext('naturemediiia')
      || isContext('designmediiia')
      || isContext('artmediiia')
      || isContext('fairmediiia')
      || isContext('admediiia')
      || isContext('kiiidsmediiia')
      || isContext('fashionmediiia')
      || isContext('foodmediiia')
      || isContext('automediiia')
      || isContext('iqmediiia')
      || isContext('booksmediiia')
      || isContext('conceptmediiia')
      || isContext('mymediiia')
    ),
    isCGRAVE: (): boolean => isContext('cgrave'),
    isGreenAward: (): boolean => isContext('greenaward'),
    isAdcrDafesNet: (): boolean => isContext('adcrdafesnet'),
    isAlshibaya: (): boolean => isContext('alshibaya'),
    isContinuumSite: (): boolean => isContext('continuumsite'),
    isGameDeziiign: (): boolean => isContext('game'),
    isIqMediiia: (): boolean => isContext('iqmedia'),
    isHseHH: (): boolean => isContext('hsehh'),
    isHseColors: (): boolean => isContext('hsecolors'),
    isHseAnimation: (): boolean => isContext('hseanimation'),
    isHseSpaceMain: (): boolean => isContext('hsespace'),
    isHseSpace: (): boolean => isApp('deziiign') && (isContext('hsespace') 
      || (
        isContext('s-architect')
        || isContext('s-biology')
        || isContext('s-hseissek')
        || isContext('s-oriental')
        || isContext('s-geography')
        || isContext('s-hseincomm')
        || isContext('s-digital')
        || isContext('s-history')
        || isContext('s-arthistory')
        || isContext('s-cinema')
        || isContext('s-cognitive')
        || isContext('s-culturology')
        || isContext('s-mathematics')
        || isContext('s-media')
        || isContext('s-fashion')
        || isContext('s-music')
        || isContext('s-production')
        || isContext('s-pro')
        || isContext('s-hsetto')
        || isContext('s-psychology')
        || isContext('s-public-administration')
        || isContext('s-physics')
        || isContext('s-chemistry')
        || isContext('s-economy')
        || isContext('s-extra')
        || isContext('hsespacecreative')
        || isContext('hsespacefilm')
        || isContext('s-urban-development')
        || isContext('s-computer-science-and-engineering')
        || isContext('s-international-relations')
        || isContext('s-management')
        || isContext('s-political-science')
        || isContext('s-advertising-and-pr')
        || isContext('s-software-engineering')
        || isContext('s-sociology')
        || isContext('s-philology')
        || isContext('s-philosophy')
        || isContext('s-jurisprudence')
        || isContext('s-mediadepartment')
        || isContext('hsecreativehub')
        || isContext('s-virtualspace')
      )
    ),
    isCreativeSpace: (): boolean => isApp('deziiign') && isContext('hsespacecreative'),
    isLectureMediiia: (): boolean => isApp('deziiign') && isContext('lmsmediiia'),
    isNamesMediiia: (): boolean => isApp('deziiign') && isContext('namesmediiia'),
    isScienceMediiia: (): boolean => isApp('deziiign') && isContext('sciencemediiia'),
    isSchool: (): boolean => isApp('deziiign') && isContext('school'),
    isGeoMain: (): boolean => isApp('geograffee') && isContext('main'),
    isGeoDafes: (): boolean => isApp('geograffee') && isContext('dafes'),
    isNewDafesDesign: (): boolean => isApp('kz') && isContext('dafes'),
    isNewDafesArt: (): boolean => isApp('kz') && isContext('dafes-art'),
    isNewDafesFashion: (): boolean => isApp('kz') && isContext('dafes-fashion'),
    isNewDafesEducation: (): boolean => isApp('kz') && isContext('dafes-education'),
    isNewDafesSegment: (): boolean => isApp('kz') && (isContext('dafes') 
    || isContext('dafes-art') 
    || isContext('dafes-fashion') 
    || isContext('dafes-education')
    || isContext('pro')
    || isContext('lms')
  ),
    isFtbl: (): boolean => isApp('ftbl'),
    isPortfolio365: (): boolean => isApp('deziiign') && isContext('awards'),
    isKiiidsArt: (): boolean => isApp('deziiign') && isContext('kiiids'),
    isAcademy: (): boolean => isApp('geograffee') && isContext('academy'),
    isCompetitionEducation: (): boolean => isContext('competition'),
    isResearch: (): boolean => isApp('deziiign') && isContext('research'),
    isBooksDeziiign: (): boolean => (isApp('deziiign') && isContext('books')),
    isBooksMain: (): boolean => (isApp('deziiign') && isContext('books')) || isContext('booksgallllery'),
    isBooksGallllery: (): boolean => isContext('booksgallllery'),
    isBooksMediiia: (): boolean => isContext('booksmediiia'),
    //todo убрать window
    isBooks: (): boolean => (
      ((isApp('deziiign') && isContext('books')) || isContext('booksgallllery'))
      || window.location.pathname.startsWith('/books')
      || window.location.pathname.startsWith('/hsebooks')
    ),
    isBrnd: (): boolean => isApp('deziiign') && isContext('brnd'),

    // Контексты Gallllery
    isGalllleryMain: (): boolean => isApp('gallllery') && isContext('main'),
    isMediaclub: (): boolean => isApp('gallllery') && isContext('mediaclub'),
    isSuperPuper: (): boolean => isApp('deziiign') && isContext('superpuper'),
    isZelandTheme: (): boolean =>
      (isApp('deziiign') && isContext('jhonatanet'))
      || isContext('cgrave')
      || isContext('continuumsite')
      || (isApp('deziiign') && isContext('superpuper')),
    isFashionDeziiign: (): boolean => isApp('deziiign') && isContext('fashion'),
    isProDeziiign: (): boolean => (isApp('deziiign') || isApp('kz')) && ( isContext('pro') || isContext('prohse') || isContext('dafes-education') ),
    isProHSE: (): boolean => isApp('deziiign') && isContext('prohse'),
    isLMSHSE: (): boolean => isApp('deziiign') && isContext('lmshse') || (isApp('kz') && isContext('dafes-education')),
    isLMSHSECreative: (): boolean => isApp('deziiign') && isContext('lmshsecreative'),
    isExamHSE: (): boolean => isApp('deziiign') && isContext('exams'),
    isDvaDesign: (): boolean => isApp('deziiign') && isContext('dvadesign'),
    isGalllleryArt: (): boolean => isApp('deziiign') && isContext('galllleryart'),
    isDaMuseum: (): boolean => isApp('deziiign') && isContext('damuseum'),
    isCreativeHSE: (): boolean => isApp('deziiign') && isContext('hsecreative'),
    isStartHSE: (): boolean => isApp('deziiign') && isContext('hsestart'),
    isHseRanepa: (): boolean => isApp('deziiign') && isContext('ranepa'),
    isLPUDesign: (): boolean => isApp('deziiign') && isContext('lpudesign'),
    isMonaLisaTravels: (): boolean => isApp('deziiign') && isContext('monalisatravels'),
    isKz: (): boolean => isApp('kz'),
    isFr: (): boolean => isApp('fr'),
    isIntuitParis: (): boolean => isApp('fr') && isContext('paris'),
    isIntuitMarseille: (): boolean => isApp('fr') && isContext('marseille'),
    isIntuitSaopaulo: (): boolean => isApp('fr') && isContext('saopaulo'),
    isIntuitMumbai: (): boolean => isApp('fr') && isContext('mumbai'),
    isIntuitKolkata: (): boolean => isApp('fr') && isContext('kolkata'),  
    isIntuitDubai: (): boolean => isApp('fr') && isContext('dubai'),
    isIntuitShanghai: (): boolean => isApp('fr') && isContext('shanghai'),
    isUz: (): boolean => isApp('uz'),
    isAKI: (): boolean => isApp('deziiign') && isContext('aki'),
    isNewCha: (): boolean => isContext('newcha'),
    isPromtWeekend: (): boolean => {
      if (typeof window === 'undefined') return false;
      if (!isContext('aimediiia')) return false;
      
      const pathname = window.location.pathname;
      
      if (
        pathname.startsWith('/ai/prompt-weekend') ||
        pathname.startsWith('/ai/prompt-video') ||
        pathname.startsWith('/ai/prompt-brand') ||
        pathname.startsWith('/ai/prompt-code')
      ) {
        return true;
      }
      
      const PROMT_WEEKEND_MODULES = [
        '6f879803bcc842c8b9ae08007e6b607f',
        '5b488948d1674daab6b8cc4288a42ef9',
        'e90d23c67aad4027b11a536948206a19',
      ];
      
      const projectMatch = pathname.match(/^\/ai\/(project|edit|preview)\/([a-f0-9-]+)/);
      if (projectMatch && PROMT_WEEKEND_MODULES.includes(projectMatch[2])) {
        return true;
      }

      return false;
    },
  };
};

export type AppTesterType = ReturnType<typeof buildAppTester>;

export const AppTester: AppTesterType = buildAppTester(() => ApplicationShared.application);

export const mediiiaPaths: any = {
      'historymediiia': '/history',
      'profmediiia': '/work',
      'cinemediiia': '/cine',
      'aimediiia': '/ai',
      'eventmediiia': '/365', 
      'musicmediiia': '/sound',
      'storiesmediiia': '/stories',
      'naturemediiia': '/astro',
      'booksmediiia': '/books',
      'designmediiia': '/design',
      'artmediiia': '/art',
      'fairmediiia': '/fair',
      'admediiia': '/advert',
      'kiiidsmediiia': '/kiiids',
      'foodmediiia': '/food',
      'automediiia': '/auto',
      'conceptmediiia': '/concept'
  }

export const getCurrentMediiiaContextAdress = () => {
  if (!AppTester.isMediiia()) return ''

  const {
    REACT_APP_URL_MEDIIIA_COM,
    REACT_APP_URL_EDUCATION_MEDIIIA_COM,
    REACT_APP_URL_MY_MEDIIIA_COM,
    REACT_APP_URL_SPORT_MEDIIIA_COM,
  } = process.env

  const isLectureMediiia = AppTester.isLectureMediiia()
  const isMediiiaSport = AppTester.isMediiiaSport()
  const isMyMediiia = AppTester.isMyMediiia()

  const baseUrl = 
    isLectureMediiia?
      REACT_APP_URL_EDUCATION_MEDIIIA_COM :
    isMediiiaSport?
      REACT_APP_URL_SPORT_MEDIIIA_COM :
    isMyMediiia?
      REACT_APP_URL_MY_MEDIIIA_COM 
      :
      REACT_APP_URL_MEDIIIA_COM

  const currentContext = getCurrentContextName()

  return `${baseUrl}${mediiiaPaths[currentContext] || ''}`
}

type CallbackKeys = 'isContext' | 'isApp' | 'isBooks' | 'isPromtWeekend';
const CallbackKeysArray = ['isContext', 'isApp', 'isBooks', 'isPromtWeekend'];

type AnyOfResult = {
  [K in keyof AppTesterType as K extends CallbackKeys ? never : K]: boolean;
};

export const isAnyOf = (): AnyOfResult => {
  return Object.entries(AppTester).slice(2).reduce((res, [key, callback]: [string, () => boolean]) => {
    if (CallbackKeysArray.includes(key as CallbackKeys)) {
      return res;
    }
    return {
      ...res,
      [key as keyof AnyOfResult]: callback(),
    };
  }, {} as AnyOfResult);
}


/**
 * Это очень важный файл, здесь мы тоже работаем, например модифицируем enum'ы и тд.
 *
 * Здесь происходит вторая регистрация проектов и контекстов.
 *
 * Никакого хардкода!!
 */

import { isServer } from 'shared/constants/isServer';
import { bString } from './core';
import { ApplicationShared } from './core';
import { DEZIIIGN_CONTEXTS } from 'shared/constants/enginePaths';

export enum AppName {
  deziiign = 'deziiign',
  geograffee = 'geograffee',
  designlab = 'labolatory',
  gallllery = 'gallllery',
  mediiia = 'mediiia',
  competition = 'competition',
  hsedesign = 'hsedesign',
  dafesNetKZ = 'kz',
  fr = 'fr',
  uz = 'uz',
  ftbl = 'ftbl',
}

export enum AppContext {
  education = 'education',
  main = 'main',
  design = 'design',
  art = 'art',
  fashion = 'fashion',
  events = 'events',
  space = 'space',
  urban = 'urban',
  places = 'places',
}

export enum AppMode {
  production = 'production',
  develop = 'develop',
  staging = 'staging',
}

const AppContextTitleMap: Record<string, string> = {
  education: 'education',
  main: 'deziiign',
  design: 'design',
  art: 'art',
  fashion: 'fashion',
  events: 'events',
  space: 'space',
  media: 'creative',
  places: 'places',
  creative: 'creative',
};

/**
 * Конфигурация стартера
 */
export const StarterSettings = {
  // Стартовый файл
  appStarterFile: 'app.tsx',

  // Стартовый заголовок
  appDefaultTitle: 'Burgundy Engine',
};

/**
 * Получение контекста из названия мини-приложения
 * @param appName
 */
export const getContextFromAppName = (appName: string): string => {
  const parts = appName.split('/');

  const contextName = parts.length === 1 || !parts[1] || bString.isEmpty(parts[1]) ? 'main' : parts[1];

  if (contextName === 'hsealumni') {
    return 'education'
  }

  return contextName;
};

export const getAppNameFromAppString = (appName: string): string => appName.split('/')[0];

export const getCurrentContextName = (): string => getContextFromAppName(ApplicationShared.application);

export const getCurrentContextTitle = (): string => AppContextTitleMap[getCurrentContextName()] || '';

/**
 * Возвращает название  мини-приложения ЗАПУЩЕННОГО В ТЕКУЩИЙ МОМЕНТ
 */
export const getCurrentAppName = (): string => getAppNameFromAppString(ApplicationShared.application);

// const safeWindow = isServer ? {
//     location: {
//         pathname: '/',
//     }
// } : window;

export const buildAppTester = (getApplication: () => string) => {
  const getContextName = () => getContextFromAppName(getApplication());
  const getAppName = () => getAppNameFromAppString(getApplication());
  const isContext = (c?: string): boolean => getContextName() === c;
  const isApp = (a?: string): boolean => getAppName() === a;

  return {
    isContext,
    isApp,
    getContextName,
    getAppName,
    // Тестирование приложений
    isDeziiign: (): boolean => isApp('deziiign') || isApp('fr') || isApp('uz'),
    isGallllery: (): boolean => isApp('gallllery'),
    isMediiiaMain: (): boolean => isApp('deziiign') && isContext('mediiia'),
    isMediiiaStories: (): boolean => isApp('deziiign') && isContext('storiesmediiia'),
    isMediiiaNature: (): boolean => isApp('deziiign') && isContext('naturemediiia'),
    isMediiiaSport: (): boolean => isApp('deziiign') && isContext('sportmediiia'),
    isMediiiaProf: (): boolean => isApp('deziiign') && isContext('profmediiia'),
    isMediiiaCine: (): boolean => isApp('deziiign') && isContext('cinemediiia'),
    isMediiiaAi: (): boolean => isApp('deziiign') && isContext('aimediiia'),
    isMediiiaArt: (): boolean => isApp('deziiign') && isContext('artmediiia'),
    isMediiiaFair: (): boolean => isApp('deziiign') && isContext('fairmediiia'),
    isMediiiaAd: (): boolean => isApp('deziiign') && isContext('admediiia'),
    isKiiidsMediiia: (): boolean => isApp('deziiign') && isContext('kiiidsmediiia'),
    isMediiiaKiiids: (): boolean => isApp('deziiign') && isContext('kiiidsmediiia'),
    isMediiiaUrban: (): boolean => isApp('deziiign') && isContext('urbanmediiia'),
    isMediiiaFood: (): boolean => isApp('deziiign') && isContext('foodmediiia'),
    isMediiiaAuto: (): boolean => isApp('deziiign') && isContext('automediiia'),
    isMediiiaConcept: (): boolean => isApp('deziiign') && isContext('conceptmediiia'),  
    isDesignMediiia: (): boolean => isApp('deziiign') && isContext('designmediiia'),
    isHistoryMediiia: (): boolean => isApp('deziiign') && isContext('historymediiia'),
    isMusicMediiia: (): boolean => isApp('deziiign') && isContext('musicmediiia'),
    isMediiia365: (): boolean => isApp('deziiign') && isContext('365'),
    isEventMediiia: (): boolean => isApp('deziiign') && isContext('eventmediiia'),
    isArtMediiia: (): boolean => isApp('deziiign') && isContext('artmediiia'),
    isAstroMediiia: (): boolean => isApp('deziiign') && isContext('astromediiia'),
    isMyMediiia: (): boolean => isApp('deziiign') && isContext('mymediiia'),
    isGeograffee: (): boolean => isApp('geograffee'),
    isAgeytomesh: (): boolean => isContext('ageytomesh'),
    isCompetition: (): boolean => isApp('competition'),
    isFairArtz: (): boolean => isApp('deziiign') && isContext('fairartz'),
    isPortfolioArtz: (): boolean => isApp('deziiign') && isContext('portfolioartz'),
    isArtzWork: (): boolean => isApp('deziiign') && isContext('fairartz') || isContext('portfolioartz'),
    isJhonataNet: (): boolean => isApp('deziiign') && isContext('jhonatanet'),
    // Контексты
    isMainContext: (): boolean => isContext('main'),
    isLabDeziiign: (): boolean => isApp('deziiign') && isContext('lab'),
    isHSEBiotech: (): boolean => isApp('deziiign') && isContext('s-biology'),
    isHSESpaceSegmants: (): boolean => isContext('s-architect')
      || isContext('s-biology')
    || isContext('s-hseissek')
      || isContext('s-oriental')
      || isContext('s-geography')
      || isContext('s-hseincomm')
      || isContext('s-digital')
      || isContext('s-history')
      || isContext('s-arthistory')
      || isContext('s-cinema')
      || isContext('s-cognitive')
      || isContext('s-culturology')
      || isContext('s-mathematics')
      || isContext('s-media')
      || isContext('s-fashion')
      || isContext('s-music')
      || isContext('s-production')
      || isContext('s-pro')
      || isContext('s-hsetto')
      || isContext('s-psychology')
      || isContext('s-public-administration')
      || isContext('s-physics')
      || isContext('s-chemistry')
      || isContext('s-economy')
      || isContext('s-extra')
      || isContext('hsespacecreative')
      || isContext('hsespacefilm')
      || isContext('s-urban-development')
      || isContext('s-computer-science-and-engineering')
      || isContext('s-international-relations')
      || isContext('s-management')
      || isContext('s-political-science')
      || isContext('s-advertising-and-pr')
      || isContext('s-software-engineering')
      || isContext('s-sociology')
      || isContext('s-philology')
      || isContext('s-philosophy')
      || isContext('s-jurisprudence')
      || isContext('s-mediadepartment')
      || isContext('hsecreativehub')
      || isContext('s-virtualspace')
      || isContext('s-biology'),
    // Контексты Deziiign
    isDeziiignMain: (): boolean => isApp('deziiign') && isContext('main'),
    isDeziiignContext: (): boolean => DEZIIIGN_CONTEXTS.includes(getApplication()),
    isDeziiignEssential: (): boolean => isApp('deziiign') && !(
      (isApp('deziiign') && (isContext('hsedesign')
        || isContext('prohse')
        || isContext('lmshse')
        || isContext('hsehh')
        || isContext('hsecolors')
        || isContext('hsecreative')
        || isContext('damuseum')
        || isContext('hsestart')
        || isContext('exams')
        || isContext('hsespace')
        || (isContext('s-architect')
          || isContext('s-biology')
          || isContext('s-hseissek')
          || isContext('s-oriental')
          || isContext('s-geography')
          || isContext('s-hseincomm')
          || isContext('s-digital')
          || isContext('s-history')
          || isContext('s-arthistory')
          || isContext('s-cinema')
          || isContext('s-cognitive')
          || isContext('s-culturology')
          || isContext('s-mathematics')
          || isContext('s-media')
          || isContext('s-fashion')
          || isContext('s-music')
          || isContext('s-production')
          || isContext('s-pro')
          || isContext('s-hsetto')
          || isContext('s-psychology')
          || isContext('s-public-administration')
          || isContext('s-physics')
          || isContext('s-chemistry')
          || isContext('s-economy')
          || isContext('s-extra')
          || isContext('hsespacecreative')
          || isContext('hsespacefilm')
          || isContext('s-urban-development')
          || isContext('s-computer-science-and-engineering')
          || isContext('s-international-relations')
          || isContext('s-management')
          || isContext('s-political-science')
          || isContext('s-advertising-and-pr')
          || isContext('s-mediadepartment')
          || isContext('s-software-engineering')
          || isContext('s-sociology')
          || isContext('s-philology')
          || isContext('s-philosophy')
          || isContext('s-jurisprudence')
          || isContext('hsecreativehub')
        )
      )) || (isApp('deziiign') && isContext('onlines')) || (isApp('deziiign') && isContext('school'))
    ),
    isHSEDesign: (): boolean => isApp('deziiign') && (isContext('hsedesign')
      || isContext('prohse')
      || isContext('lmshse')
      || isContext('hsehh')
      || isContext('hsecolors')
      || isContext('hsecreative')
      || isContext('damuseum')
      || isContext('hsestart')
      || isContext('exams')
      || isContext('hsespace')
      || (
        isContext('s-architect')
        || isContext('s-biology')
        || isContext('s-hseissek')
        || isContext('s-oriental')
        || isContext('s-geography')
        || isContext('s-hseincomm')
        || isContext('s-digital')
        || isContext('s-history')
        || isContext('s-arthistory')
        || isContext('s-cinema')
        || isContext('s-cognitive')
        || isContext('s-culturology')
        || isContext('s-mathematics')
        || isContext('s-media')
        || isContext('s-fashion')
        || isContext('s-music')
        || isContext('s-production')
        || isContext('s-pro')
        || isContext('s-hsetto')
        || isContext('s-psychology')
        || isContext('s-public-administration')
        || isContext('s-physics')
        || isContext('s-chemistry')
        || isContext('s-economy')
        || isContext('s-extra')
        || isContext('hsespacecreative')
        || isContext('hsespacefilm')
        || isContext('s-urban-development')
        || isContext('s-computer-science-and-engineering')
        || isContext('s-international-relations')
        || isContext('s-management')
        || isContext('s-political-science')
        || isContext('s-advertising-and-pr')
        || isContext('s-software-engineering')
        || isContext('s-sociology')
        || isContext('s-philology')
        || isContext('s-philosophy')
        || isContext('s-jurisprudence')
        || isContext('s-mediadepartment')
        || isContext('hsecreativehub')
      )
    ),
    isOnlineHSEDesign: (): boolean => isApp('deziiign') && isContext('online'),
    isOnlines: (): boolean => isApp('deziiign') && isContext('onlines'),
    isOnlinesDesign: (): boolean => isApp('deziiign') && isContext('onlinesdesign'),
    isMediiia: (): boolean => isApp('deziiign') && (isContext('mediiia')
      || isContext('lmsmediiia')
      || isContext('namesmediiia')
      || isContext('sciencemediiia')
      || isContext('iqmedia')
      || isContext('historymediiia')
      || isContext('transfermediiia')
      || isContext('creativemediiia')
      || isContext('sportmediiia')
      || isContext('profmediiia')
      || isContext('cinemediiia')
      || isContext('aimediiia')
      || isContext('historymediiia')
      || isContext('sportmediiia')
      || isContext('eventmediiia')
      || isContext('musicmediiia')
      || isContext('storiesmediiia')
      || isContext('naturemediiia')
      || isContext('designmediiia')
      || isContext('artmediiia')
      || isContext('fairmediiia')
      || isContext('admediiia')
      || isContext('kiiidsmediiia')
      || isContext('fashionmediiia')
      || isContext('foodmediiia')
      || isContext('automediiia')
      || isContext('iqmediiia')
      || isContext('booksmediiia')
      || isContext('conceptmediiia')
      || isContext('mymediiia')
    ),
    isCGRAVE: (): boolean => isContext('cgrave'),
    isGreenAward: (): boolean => isContext('greenaward'),
    isAdcrDafesNet: (): boolean => isContext('adcrdafesnet'),
    isAlshibaya: (): boolean => isContext('alshibaya'),
    isContinuumSite: (): boolean => isContext('continuumsite'),
    isGameDeziiign: (): boolean => isContext('game'),
    isIqMediiia: (): boolean => isContext('iqmedia'),
    isHseHH: (): boolean => isContext('hsehh'),
    isHseColors: (): boolean => isContext('hsecolors'),
    isHseAnimation: (): boolean => isContext('hseanimation'),
    isHseSpaceMain: (): boolean => isContext('hsespace'),
    isHseSpace: (): boolean => isApp('deziiign') && (isContext('hsespace') 
      || (
        isContext('s-architect')
        || isContext('s-biology')
        || isContext('s-hseissek')
        || isContext('s-oriental')
        || isContext('s-geography')
        || isContext('s-hseincomm')
        || isContext('s-digital')
        || isContext('s-history')
        || isContext('s-arthistory')
        || isContext('s-cinema')
        || isContext('s-cognitive')
        || isContext('s-culturology')
        || isContext('s-mathematics')
        || isContext('s-media')
        || isContext('s-fashion')
        || isContext('s-music')
        || isContext('s-production')
        || isContext('s-pro')
        || isContext('s-hsetto')
        || isContext('s-psychology')
        || isContext('s-public-administration')
        || isContext('s-physics')
        || isContext('s-chemistry')
        || isContext('s-economy')
        || isContext('s-extra')
        || isContext('hsespacecreative')
        || isContext('hsespacefilm')
        || isContext('s-urban-development')
        || isContext('s-computer-science-and-engineering')
        || isContext('s-international-relations')
        || isContext('s-management')
        || isContext('s-political-science')
        || isContext('s-advertising-and-pr')
        || isContext('s-software-engineering')
        || isContext('s-sociology')
        || isContext('s-philology')
        || isContext('s-philosophy')
        || isContext('s-jurisprudence')
        || isContext('s-mediadepartment')
        || isContext('hsecreativehub')
        || isContext('s-virtualspace')
      )
    ),
    isCreativeSpace: (): boolean => isApp('deziiign') && isContext('hsespacecreative'),
    isLectureMediiia: (): boolean => isApp('deziiign') && isContext('lmsmediiia'),
    isNamesMediiia: (): boolean => isApp('deziiign') && isContext('namesmediiia'),
    isScienceMediiia: (): boolean => isApp('deziiign') && isContext('sciencemediiia'),
    isSchool: (): boolean => isApp('deziiign') && isContext('school'),
    isGeoMain: (): boolean => isApp('geograffee') && isContext('main'),
    isGeoDafes: (): boolean => isApp('geograffee') && isContext('dafes'),
    isNewDafesDesign: (): boolean => isApp('kz') && isContext('dafes'),
    isNewDafesArt: (): boolean => isApp('kz') && isContext('dafes-art'),
    isNewDafesFashion: (): boolean => isApp('kz') && isContext('dafes-fashion'),
    isNewDafesEducation: (): boolean => isApp('kz') && isContext('dafes-education'),
    isNewDafesSegment: (): boolean => isApp('kz') && (isContext('dafes') 
    || isContext('dafes-art') 
    || isContext('dafes-fashion') 
    || isContext('dafes-education')
    || isContext('pro')
    || isContext('lms')
  ),
    isFtbl: (): boolean => isApp('ftbl'),
    isPortfolio365: (): boolean => isApp('deziiign') && isContext('awards'),
    isKiiidsArt: (): boolean => isApp('deziiign') && isContext('kiiids'),
    isAcademy: (): boolean => isApp('geograffee') && isContext('academy'),
    isCompetitionEducation: (): boolean => isContext('competition'),
    isResearch: (): boolean => isApp('deziiign') && isContext('research'),
    isBooksDeziiign: (): boolean => (isApp('deziiign') && isContext('books')),
    isBooksMain: (): boolean => (isApp('deziiign') && isContext('books')) || isContext('booksgallllery'),
    isBooksGallllery: (): boolean => isContext('booksgallllery'),
    isBooksMediiia: (): boolean => isContext('booksmediiia'),
    //todo убрать window
    isBooks: (): boolean => (
      ((isApp('deziiign') && isContext('books')) || isContext('booksgallllery'))
      || window.location.pathname.startsWith('/books')
      || window.location.pathname.startsWith('/hsebooks')
    ),
    isBrnd: (): boolean => isApp('deziiign') && isContext('brnd'),

    // Контексты Gallllery
    isGalllleryMain: (): boolean => isApp('gallllery') && isContext('main'),
    isMediaclub: (): boolean => isApp('gallllery') && isContext('mediaclub'),
    isSuperPuper: (): boolean => isApp('deziiign') && isContext('superpuper'),
    isZelandTheme: (): boolean =>
      (isApp('deziiign') && isContext('jhonatanet'))
      || isContext('cgrave')
      || isContext('continuumsite')
      || (isApp('deziiign') && isContext('superpuper')),
    isFashionDeziiign: (): boolean => isApp('deziiign') && isContext('fashion'),
    isProDeziiign: (): boolean => (isApp('deziiign') || isApp('kz')) && ( isContext('pro') || isContext('prohse') || isContext('dafes-education') ),
    isProHSE: (): boolean => isApp('deziiign') && isContext('prohse'),
    isLMSHSE: (): boolean => isApp('deziiign') && isContext('lmshse') || (isApp('kz') && isContext('dafes-education')),
    isLMSHSECreative: (): boolean => isApp('deziiign') && isContext('lmshsecreative'),
    isExamHSE: (): boolean => isApp('deziiign') && isContext('exams'),
    isDvaDesign: (): boolean => isApp('deziiign') && isContext('dvadesign'),
    isGalllleryArt: (): boolean => isApp('deziiign') && isContext('galllleryart'),
    isDaMuseum: (): boolean => isApp('deziiign') && isContext('damuseum'),
    isCreativeHSE: (): boolean => isApp('deziiign') && isContext('hsecreative'),
    isStartHSE: (): boolean => isApp('deziiign') && isContext('hsestart'),
    isHseRanepa: (): boolean => isApp('deziiign') && isContext('ranepa'),
    isLPUDesign: (): boolean => isApp('deziiign') && isContext('lpudesign'),
    isMonaLisaTravels: (): boolean => isApp('deziiign') && isContext('monalisatravels'),
    isKz: (): boolean => isApp('kz'),
    isFr: (): boolean => isApp('fr'),
    isIntuitParis: (): boolean => isApp('fr') && isContext('paris'),
    isIntuitMarseille: (): boolean => isApp('fr') && isContext('marseille'),
    isIntuitSaopaulo: (): boolean => isApp('fr') && isContext('saopaulo'),
    isIntuitMumbai: (): boolean => isApp('fr') && isContext('mumbai'),
    isIntuitKolkata: (): boolean => isApp('fr') && isContext('kolkata'),  
    isIntuitDubai: (): boolean => isApp('fr') && isContext('dubai'),
    isIntuitShanghai: (): boolean => isApp('fr') && isContext('shanghai'),
    isUz: (): boolean => isApp('uz'),
    isAKI: (): boolean => isApp('deziiign') && isContext('aki'),
    isNewCha: (): boolean => isContext('newcha'),
    isPromtWeekend: (): boolean => {
      if (typeof window === 'undefined') return false;
      if (!isContext('aimediiia')) return false;
      
      const pathname = window.location.pathname;
      
      if (
        pathname.startsWith('/ai/prompt-weekend') ||
        pathname.startsWith('/ai/prompt-video') ||
        pathname.startsWith('/ai/prompt-brand') ||
        pathname.startsWith('/ai/prompt-code')
      ) {
        return true;
      }
      
      const PROMT_WEEKEND_MODULES = [
        '6f879803bcc842c8b9ae08007e6b607f',
        '5b488948d1674daab6b8cc4288a42ef9',
        'e90d23c67aad4027b11a536948206a19',
      ];
      
      const projectMatch = pathname.match(/^\/ai\/(project|edit|preview)\/([a-f0-9-]+)/);
      if (projectMatch && PROMT_WEEKEND_MODULES.includes(projectMatch[2])) {
        return true;
      }

      return false;
    },
  };
};

export type AppTesterType = ReturnType<typeof buildAppTester>;

export const AppTester: AppTesterType = buildAppTester(() => ApplicationShared.application);

export const mediiiaPaths: any = {
      'historymediiia': '/history',
      'profmediiia': '/work',
      'cinemediiia': '/cine',
      'aimediiia': '/ai',
      'eventmediiia': '/365', 
      'musicmediiia': '/sound',
      'storiesmediiia': '/stories',
      'naturemediiia': '/astro',
      'booksmediiia': '/books',
      'designmediiia': '/design',
      'artmediiia': '/art',
      'fairmediiia': '/fair',
      'admediiia': '/advert',
      'kiiidsmediiia': '/kiiids',
      'foodmediiia': '/food',
      'automediiia': '/auto',
      'conceptmediiia': '/concept'
  }

export const getCurrentMediiiaContextAdress = () => {
  if (!AppTester.isMediiia()) return ''

  const {
    REACT_APP_URL_MEDIIIA_COM,
    REACT_APP_URL_EDUCATION_MEDIIIA_COM,
    REACT_APP_URL_MY_MEDIIIA_COM,
    REACT_APP_URL_SPORT_MEDIIIA_COM,
  } = process.env

  const isLectureMediiia = AppTester.isLectureMediiia()
  const isMediiiaSport = AppTester.isMediiiaSport()
  const isMyMediiia = AppTester.isMyMediiia()

  const baseUrl = 
    isLectureMediiia?
      REACT_APP_URL_EDUCATION_MEDIIIA_COM :
    isMediiiaSport?
      REACT_APP_URL_SPORT_MEDIIIA_COM :
    isMyMediiia?
      REACT_APP_URL_MY_MEDIIIA_COM 
      :
      REACT_APP_URL_MEDIIIA_COM

  const currentContext = getCurrentContextName()

  return `${baseUrl}${mediiiaPaths[currentContext] || ''}`
}

type CallbackKeys = 'isContext' | 'isApp' | 'isBooks' | 'isPromtWeekend';
const CallbackKeysArray = ['isContext', 'isApp', 'isBooks', 'isPromtWeekend'];

type AnyOfResult = {
  [K in keyof AppTesterType as K extends CallbackKeys ? never : K]: boolean;
};

export const isAnyOf = (): AnyOfResult => {
  return Object.entries(AppTester).slice(2).reduce((res, [key, callback]: [string, () => boolean]) => {
    if (CallbackKeysArray.includes(key as CallbackKeys)) {
      return res;
    }
    return {
      ...res,
      [key as keyof AnyOfResult]: callback(),
    };
  }, {} as AnyOfResult);
}
